import React, { useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Add, Delete, InfoOutlined } from "@mui/icons-material";
import {
  IconButton,
  Button,
  TextField,
  Grid,
  Box,
  Typography,
  Card,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";

import Banner from "../../../assets/images/banner.webp";
import { PlanDropDown, Switch, Tooltip } from "../../../common";
import { inviteCandidateOnJob as inviteCandidateOnJobAction } from "../../../redux/slices/postsSlice";
import { connect } from "react-redux";

const validationSchema = yup.object().shape({
  participants: yup.array().of(
    yup.object().shape({
      name: yup.string().required("Name is required"),
      email: yup.string().email("Invalid email").required("Email is required"),
    })
  ),
});

const ByEmail = ({ post, onClose, inviteCandidateOnJob }) => {
  const [activeResource, setActiveResource] = useState(false);
  const [expiresIn, setExpiredIn] = useState("1 week");
  const [loading, setLoading] = useState(false);
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      participants: [{ name: "", email: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "participants",
  });

  const onSubmit = async (data) => {
    console.log(data);

    try {
      setLoading(true);

      await inviteCandidateOnJob({
        data: {
          job_post_id: post?.id,
          candidates: data?.participants,
        },
        cb: () => onClose(),
      });

      reset({
        participants: [{ name: "", email: "" }],
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <Box display="flex" borderRadius="10px" height="100%" gap={2}>
      <Box
        maxWidth="35%"
        bgcolor="#FAFAFA"
        flex={1}
        mx="auto"
        p={2}
        borderRadius="20px"
      >
        <Box>
          <Typography textAlign="left" fontSize="15px" fontWeight={700}>
            Info
          </Typography>
          <Typography fontSize="14px" color="#5B6F82" my={2}>
            {
              "With this feature, you can send personalized email invitations to candidates, inviting them to apply for jobs that have already been posted."
            }
          </Typography>
          <Typography fontSize="14px" color="#5B6F82">
            {
              "Make sure to target candidates who are a good fit for the role to increase the chances of successful applications and a better hiring experience."
            }
          </Typography>
        </Box>
      </Box>
      <Box flex={2} pr={2} overflow="auto">
        <Card
          sx={{
            border: 1,
            borderRadius: "10px",
            borderColor: "#CFCFCF",
            minHeight: "350px",
            p: 3,
            margin: "auto",
          }}
        >
          <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
            <Grid item xs={12} sm={5}>
              {" "}
              <Typography fontWeight={600}>Name</Typography>
            </Grid>
            <Grid item xs={12} sm={5}>
              {" "}
              <Typography fontWeight={600}>Email</Typography>
            </Grid>
          </Grid>
          {fields.map((field, index) => (
            <Grid
              container
              key={field.id}
              spacing={2}
              sx={{ mb: 2 }}
              alignItems="center"
            >
              <Grid item xs={12} sm={5}>
                <TextField
                  {...register(`participants.${index}.name`)}
                  label="Name"
                  required
                  fullWidth
                  error={!!errors?.participants?.[index]?.name}
                  helperText={errors?.participants?.[index]?.name?.message}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  {...register(`participants.${index}.email`)}
                  label="Email"
                  required
                  fullWidth
                  error={!!errors?.participants?.[index]?.email}
                  helperText={errors?.participants?.[index]?.email?.message}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                {index > 0 ? (
                  <IconButton
                    onClick={() => remove(index)}
                    color="error"
                    aria-label="delete"
                  >
                    <Delete />
                  </IconButton>
                ) : (
                  <Button
                    type="button"
                    variant="main"
                    startIcon={<Add />}
                    onClick={() => append({ name: "", email: "" })}
                    fullWidth
                  >
                    Add
                  </Button>
                )}
              </Grid>
            </Grid>
          ))}
        </Card>

        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          my={2}
        >
          {/* <Tooltip
            title={
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  bgcolor: "#f5f5f5",
                }}
              >
                <Paper
                  elevation={3}
                  sx={{
                    maxWidth: "600px",
                    width: "100%",
                    bgcolor: "#ffffff",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <Box component="img" src={Banner} width="100%" />

                  <Box sx={{ padding: "20px" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: "10px",
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#333333",
                      }}
                    >
                      Subject: Assessment Invitation - [Position] Role
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ marginBottom: "20px", color: "#555555" }}
                    >
                      Hi [Candidate Name],
                      <br />
                      <br />
                      Thank you for applying to the [Position] role at [Company
                      Name]. As the next step in our process, we’d like you to
                      complete an online assessment.
                      <br />
                      <br />
                      Please click the link below to access your assessment on
                      Getgeek:
                    </Typography>

                    <Box sx={{ textAlign: "center", marginBottom: "20px" }}>
                      <Button
                        variant="contained"
                        size="large"
                        sx={{
                          backgroundColor: "#4AB9F9",
                          "&:hover": { backgroundColor: "#359DDC" },
                          textTransform: "none",
                          padding: "10px 20px",
                          borderRadius: "25px",
                          fontWeight: "bold",
                        }}
                      >
                        Go to assessment
                      </Button>
                    </Box>

                    <Typography variant="body2" sx={{ color: "#555555" }}>
                      Details:
                      <br />
                      - Time: [X] minutes
                      <br />
                      - Deadline: [Date]
                      <br />- Complete in one sitting
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ marginTop: "20px", color: "#555555" }}
                    >
                      For technical support, contact: [support email]
                    </Typography>
                  </Box>

                  <Box sx={{ padding: "10px 20px", textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      textAlign="left"
                      sx={{ color: "#555555", fontWeight: "bold" }}
                    >
                      Best regards,
                    </Typography>
                    <Typography
                      textAlign="left"
                      variant="body2"
                      sx={{ color: "#555555" }}
                    >
                      [Recruiter Name]
                      <br />
                      [Company Name]
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            }
          >
            <Typography
              fontSize="14px"
              display="flex"
              gap={1}
              alignItems="center"
            >
              Invitation template{" "}
              <InfoOutlined sx={{ width: "20px", height: "20px" }} />
            </Typography>
          </Tooltip> */}
          <Button
            variant="main"
            sx={{ fontSize: "16px" }}
            disabled={loading}
            onClick={handleSubmit(onSubmit)}
          >
            {loading ? (
              <CircularProgress sx={{ color: "white" }} size={18} />
            ) : (
              "Send Invite"
            )}{" "}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const mapDipatchToProps = {
  inviteCandidateOnJob: inviteCandidateOnJobAction,
};

export default connect(null, mapDipatchToProps)(ByEmail);
